<template>
  <div v-if="textsLoaded" class="rvr-public-dashboard">
    <LoadingOverlay />
    <MessageOverlay />
    <ReservationTimer
        :nrOfReservations="nrOfReservations"
        :showMessage="showExpiredMessage"
        @timeExpired="handleTimeExpired"
    />
    <ReservationSteps />
    <StepNavigation />
    <router-view/>
    <StepNavigation />
  </div>
</template>

<script>
import ReservationTimer from "@/components/public/helpers/ReservationTimer.vue";
import useTimeExpired from "@/composables/useTimeExpired";
import useReservations from "@/composables/useReservations";
import useStepNavigation from "@/composables/useStepNavigation";
import ReservationSteps from "@/components/public/helpers/ReservationSteps.vue";
import StepNavigation from "@/components/public/helpers/StepNavigation.vue";
import MessageOverlay from "@/components/public/helpers/MessageOverlay.vue";
import LoadingOverlay from "@/components/public/helpers/LoadingOverlay.vue";
import useTexts from "@/composables/useTexts";
import {onMounted, watch} from "vue";
import usePlaces from "@/composables/usePlaces";
import useSpinner from "@/composables/useSpinner";

export default {
  name: 'PublicDashboard',
  components: {LoadingOverlay, MessageOverlay, StepNavigation, ReservationSteps, ReservationTimer},
  setup() {
    const { nrOfReservations } = useReservations();
    const { timeExpired, showExpiredMessage, handleTimeExpired } = useTimeExpired();
    const { curStep } = useStepNavigation();
    const { fetchTexts, textsLoaded } = useTexts();
    const { placesLoaded } = usePlaces();
    const { showSpinner, hideSpinner } = useSpinner();

    onMounted(() => {
      fetchTexts(window.rbs_vr_object.lang)
      showSpinner();
    });

    const stopHandle = watch(placesLoaded, (newValue) => {
      if (newValue) {
        hideSpinner();
        stopHandle();
      }
    });

    return {
      nrOfReservations,
      timeExpired,
      showExpiredMessage,
      handleTimeExpired,
      curStep,
      textsLoaded,
      placesLoaded,
    }
  }
}
</script>
